import { type CourseState } from '@editor2/types/courseState';
import { type LectureSlideDeck } from '@editor2/types/lectureSlideDecks';
import { ChangesStatus } from '@editor2/types/changesStatus';

import { addStatus, deleteProperty, isEqualIdsArrays } from './helpers';
import { insertInArrayByIndex } from '@editor2/services/helpersService';

export const addLectureSlideDecksHelper = (
	state: CourseState,
	payload: { deck: LectureSlideDeck }
) => {
	const { deck } = payload;

	state.lecture_slide_decks.entities[deck.family_id] = deck;
	state.lecture_slide_decks.ids = [...state.lecture_slide_decks.ids, deck.family_id];

	state.changes.lecture_slide_decks[deck.family_id] = [ChangesStatus.New];

	return state;
};

export const updateLectureSlideDecksHelper = (
	state: CourseState,
	payload: { lectureSlideDeckFamilyId: string; updates: Partial<LectureSlideDeck> }
) => {
	const { lectureSlideDeckFamilyId, updates } = payload;

	state.lecture_slide_decks.entities[lectureSlideDeckFamilyId] = {
		...state.lecture_slide_decks.entities[lectureSlideDeckFamilyId],
		...updates
	};

	if (!state.changes.lecture_slide_decks[lectureSlideDeckFamilyId]?.includes(ChangesStatus.New)) {
		state.changes.lecture_slide_decks[lectureSlideDeckFamilyId] = addStatus(
			state.changes.lecture_slide_decks[lectureSlideDeckFamilyId] ?? [],
			ChangesStatus.Modified
		);
	}

	return state;
};

export const deleteLectureSlideDecksHelper = (
	state: CourseState,
	payload: { lectureSlideDeckFamilyId: string }
) => {
	const { lectureSlideDeckFamilyId } = payload;
	const isNew = state.changes.lecture_slide_decks[lectureSlideDeckFamilyId]?.includes(
		ChangesStatus.New
	);

	state.lecture_slide_decks.ids = state.lecture_slide_decks.ids.filter(
		(id) => id !== lectureSlideDeckFamilyId
	);
	state.lecture_slide_decks.entities = deleteProperty(
		state.lecture_slide_decks.entities,
		lectureSlideDeckFamilyId
	);

	state.changes.lecture_slide_decks[lectureSlideDeckFamilyId] = isNew
		? []
		: [ChangesStatus.Deleted];

	return state;
};

export const reorderLectureSlideDecksHelper = (
	state: CourseState,
	payload: { lectureSlideDeckFamilyId: string; index: number }
) => {
	const { lectureSlideDeckFamilyId, index } = payload;

	const filtered = state.lecture_slide_decks.ids.filter((id) => id !== lectureSlideDeckFamilyId);
	state.lecture_slide_decks.ids = insertInArrayByIndex(filtered, lectureSlideDeckFamilyId, index);

	const initialIds = state.initialCourse.lecture_slide_decks?.ids ?? [];
	if (isEqualIdsArrays(initialIds, state.lecture_slide_decks.ids)) {
		delete state.changes.lecture_slide_decks['__order__'];
	} else {
		state.changes.lecture_slide_decks['__order__'] = [ChangesStatus.Modified];
	}

	return state;
};
